<ion-content [@slideInTop]>
  <div class="search-page-wrapper">
    <header class="search-page-header">
      <button (click)="backto()" class="back-button"></button>
      <div class="search-position-wrapper">
        <input  #searchInput (input)="searchCountrie($event)" type="text" placeholder="Chercher par rue, quartier, ville ...">
        <button *ngIf="searchTerm.length" (click)="clearSearch()" class="init-btn">X</button>
      </div>
    </header>

    <ul *ngIf="searchTerm.length">
      <li class="country-div" *ngFor="let country of countriesList.slice().reverse()" (click)="useInMap(country)">
        <h3 class="rue">{{country.rue}}</h3>
        <p class="country">{{country.country}}, {{country.pays}}</p>
      </li>
    </ul>

    <div *ngIf="(searchTerm.length && !countriesList.length && !submitted) || (searchTerm.length && submitted)" class="adress-introuvable" (click)="backtoMap()">
      <p>Adresse introuvable ?</p>
      <a>Indiquez sur la carte</a>
    </div>
  </div>

</ion-content>